import React, { useState } from "react";
import { TextField, Button, Box, Container, Typography } from "@mui/material";
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import {useNavigate} from "react-router-dom";
const host = window?.location?.hostname ?? 'localhost'
const RegistrationForm = () => {
    const [serverMessage, setServerMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isConfirmed, setIsConfirmed] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const [form, setForm] = useState({
        email: "",
        password: "",
        confirmPassword: "",
    });

    const [errors, setErrors] = useState({
        email: "",
        password: "",
        confirmPassword: "",
    });

    const validatePassword = (password) => {
        return /^(?=.*[A-Za-z-])(?=.*\d)[A-Za-z-\d]{8,}$/.test(password);
    };
    const validateEmail = (email) => {
        return /^[\w\.-]+@[\w\.-]+\.\w+$/.test(email);
    };

    const handleRegister = async () => {
        let email = form.email, password = form.password;

        try {
            const response = await fetch(`https://${host}/register`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password }),
            });

            let data;
            try {
                data = await response.json(); // Пытаемся разобрать JSON
            } catch {
                data = {}; // Если JSON нет или он битый, работаем без него
            }

            if (!response.ok) {
                // Если сервер вернул ошибку (4xx или 5xx)
                const errorMessage = data.message || `Ошибка ${response.status}: ${response.statusText}`;
                setErrorMessage(errorMessage);
                return;
            }
            setErrorMessage('')
            setIsConfirmed(true)
            if (data.message) {
                setServerMessage(data.message);
            } else {
                setServerMessage("Регистрация прошла успешно!");
            }

        } catch (error) {
            setErrorMessage("Ошибка сети или сервера. Проверьте подключение.");
        }
    };
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };
    // Функция для обработки изменения значения в поле

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });

        // Валидация полей
        if (name === "email") {
            setErrors({ ...errors, email: validateEmail(value) ? "" : "Некорректный email" });
        } else if (name === "password") {
            setErrors({ ...errors, password: validatePassword(value) ? "" : "Пароль должен содержать минимум 8 символов, буквы и цифры" });
        } else if (name === "confirmPassword") {
            setErrors({ ...errors, confirmPassword: value === form.password ? "" : "Пароли не совпадают" });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!errors.email && !errors.password && !errors.confirmPassword) {
            console.log("Регистрация успешна!", form);
        }
    };

    return (
        <Container sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "top",
            height: "100vh",
            //marginTop:"-230px"
        }} >
            <Box  sx={{
                //marginTop: '50px',
                display: "flex",
                flexDirection: "column",
                gap: 2,
                width: 300,
                height: "560px",
                padding: 3,
                boxShadow: 3,
                textAlign: "center",
            }} >
                <Typography variant="h5" sx={{textAlign: "center", mb: 2}}>Регистрация</Typography>
                <Typography variant="string" color='success' sx={{ textAlign: "center", mb: 2}}>{serverMessage ? serverMessage : ''}</Typography>
                <Typography variant="string" color='error' sx={{
                    position: 'fixed',
                    width: '300px',
                   // wordWrap:
                    marginTop: '32px',
                    marginLeft: '-32px',
                    textAlign: "center", mb: 2}}>{errorMessage ? errorMessage : ''}</Typography>
                {!isConfirmed ?
                    <form onSubmit={handleSubmit}>
                        <TextField
                            fullWidth
                            label="Почта"
                            name="email"
                            type="email"
                            value={form.email}
                            onChange={handleChange}
                            error={!!errors.email}
                            helperText={errors.email}
                            sx={{mb: 2}}
                        />
                        <TextField
                            fullWidth
                            label="Пароль"
                            name="password"
                            type={showPassword ? 'text' : 'password'}
                            value={form.password}
                            onChange={handleChange}
                            error={!!errors.password}
                            helperText={errors.password}
                            sx={{mb: 2}}
                            slotProps={
                                {
                                    input:
                                        {
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="Показать пароль"
                                                        onClick={handleClickShowPassword}
                                                        edge="end"
                                                    >
                                                        {showPassword ? <VisibilityOff/> : <Visibility/>}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }
                                }}
                        />
                        <TextField
                            fullWidth
                            label="Подтвердите пароль"
                            name="confirmPassword"
                            type={showPassword ? 'text' : 'password'}
                            value={form.confirmPassword}
                            onChange={handleChange}
                            error={!!errors.confirmPassword}
                            helperText={errors.confirmPassword}
                            sx={{mb: 3}}
                            slotProps={
                                {
                                    input:
                                        {
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="Показать пароль"
                                                        onClick={handleClickShowPassword}
                                                        edge="end"
                                                    >
                                                        {showPassword ? <VisibilityOff/> : <Visibility/>}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }
                                }}
                        />
                        <Button
                            onClick={handleRegister}
                            fullWidth
                            variant="contained"
                            color="primary"
                            type="submit"
                            disabled={!!errors.email || !!errors.password || !!errors.confirmPassword || !form.email || !form.password || !form.confirmPassword}
                        >
                            Зарегистрироваться
                        </Button>
                        <br/><br/>
                        <Button variant="outlined" color="primary" onClick={() => {
                            navigate("/LoginForm")
                        }} fullWidth>
                            Назад
                        </Button>
                    </form> : ''}
            </Box>
        </Container>
    );
};

export default RegistrationForm;
